import React from 'react';
import { AppName } from '../../utils/globals';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/InfoRounded';
import { Dialog, DialogContent, DialogActions, DialogTitle } from '@material-ui/core';

import './InfoDialog.scss';

export default function InfoDialog() {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div className="text-right">
            <IconButton className="info-modal-button" aria-label="info"
                onClick={handleClickOpen}>
                <InfoIcon />
            </IconButton>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle className="pb-0">
                    What is this?
                </DialogTitle>
                <DialogContent>
                    <div id="alert-dialog-description" className="m-0">
                        <p>
                            {AppName} helps you get a better look at your Amazon spending by
                            organizing your purchases in charts and providing other useful information.
                        </p>
                        <br />
                        <p>
                            This application runs entirely in your browser,
                            no data is stored or sent anywhere.
                        </p>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant="text" color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
